/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Integrations_Mcp_Access_TitleInputs */



/**
* | output |
* | --- |
* | "Use oneAI in other apps" |
*
* @param {My_Integrations_Mcp_Access_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const my_integrations_mcp_access_title = /** @type {((inputs?: My_Integrations_Mcp_Access_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Integrations_Mcp_Access_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("oneAI in anderen Apps nutzen")
	return /** @type {LocalizedString} */ ("Use oneAI in other apps")
});